import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Legend,
} from 'recharts';
import { Box, Text } from 'grommet';

const ProviderBarChart = ({
  data,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  chartTooltip,
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>
        Hosting Provider Stats
      </Text>
      <Text color={secondaryText} size="0.8rem">
        Provider contribution by total infringements and affected domains.
      </Text>
    </Box>
    <Box height="19rem" width="100%">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ left: 10, right: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
          <XAxis type="number" tick={{ fill: '#5D738A', fontSize: 11 }} />
          <YAxis type="category" dataKey="provider" width={110} tick={{ fill: '#5D738A', fontSize: 11 }} />
          <Legend />
          <Tooltip {...chartTooltip} />
          <Bar dataKey="infringements" name="Infringements" fill="#F97316" radius={[0, 4, 4, 0]} />
          <Bar dataKey="domains" name="Domains" fill="#2563EB" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  </Box>
);

ProviderBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  chartTooltip: PropTypes.object.isRequired,
};

export default ProviderBarChart;
